export default __webpack_public_path__ + "static/media/comment.8aa21fcc.svg";